import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "**:data-[slot=native-select-icon]:right-1" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "absolute inset-0 flex h-full items-center text-sm pl-2 pointer-events-none" }
const _hoisted_4 = { class: "**:data-[slot=native-select-icon]:right-1" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "absolute inset-0 flex h-full items-center text-sm pl-2 pointer-events-none" }
const _hoisted_7 = { class: "flex items-center gap-1 absolute top-0 inset-x-0 justify-between" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center gap-1"
}
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-center gap-1"
}
const _hoisted_10 = {
  key: 2,
  class: "flex items-center justify-center gap-1"
}
const _hoisted_11 = { class: "flex flex-col gap-y-4 mt-4 sm:flex-row sm:gap-x-4 sm:gap-y-0" }

import type { CalendarRootEmits, CalendarRootProps, DateValue } from "reka-ui"
import type { HTMLAttributes, Ref } from "vue"
import type { LayoutTypes } from "."
import { getLocalTimeZone, today } from "@internationalized/date"
import { createReusableTemplate, reactiveOmit, useVModel } from "@vueuse/core"
import { CalendarRoot, useDateFormatter, useForwardPropsEmits } from "reka-ui"
import { createYear, createYearRange, toDate } from "reka-ui/date"
import { computed, toRaw } from "vue"
import { cn } from "@/lib/utils"
import { NativeSelect, NativeSelectOption } from '@/components/ui/native-select'
import { CalendarCell, CalendarCellTrigger, CalendarGrid, CalendarGridBody, CalendarGridHead, CalendarGridRow, CalendarHeadCell, CalendarHeader, CalendarHeading, CalendarNextButton, CalendarPrevButton } from "."


export default /*@__PURE__*/_defineComponent({
  __name: 'Calendar',
  props: {
    defaultValue: {},
    defaultPlaceholder: {},
    placeholder: {},
    pagedNavigation: { type: Boolean },
    preventDeselect: { type: Boolean },
    weekStartsOn: {},
    weekdayFormat: {},
    calendarLabel: {},
    fixedWeeks: { type: Boolean },
    maxValue: {},
    minValue: {},
    locale: {},
    numberOfMonths: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    initialFocus: { type: Boolean },
    isDateDisabled: {},
    isDateUnavailable: {},
    dir: {},
    nextPage: {},
    prevPage: {},
    modelValue: { default: undefined },
    multiple: { type: Boolean },
    disableDaysOutsideCurrentView: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {},
    layout: { default: undefined },
    yearRange: {}
  },
  emits: ["update:modelValue", "update:placeholder"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const delegatedProps = reactiveOmit(props, "class", "layout", "placeholder")

const placeholder = useVModel(props, "placeholder", emits, {
  passive: true,
  defaultValue: props.defaultPlaceholder ?? today(getLocalTimeZone()),
}) as Ref<DateValue>

const formatter = useDateFormatter(props.locale ?? "en")

const yearRange = computed(() => {
  return props.yearRange ?? createYearRange({
    start: props?.minValue ?? (toRaw(props.placeholder) ?? props.defaultPlaceholder ?? today(getLocalTimeZone()))
      .cycle("year", -100),

    end: props?.maxValue ?? (toRaw(props.placeholder) ?? props.defaultPlaceholder ?? today(getLocalTimeZone()))
      .cycle("year", 10),
  })
})

const [DefineMonthTemplate, ReuseMonthTemplate] = createReusableTemplate<{ date: DateValue }>()
const [DefineYearTemplate, ReuseYearTemplate] = createReusableTemplate<{ date: DateValue }>()

const forwarded = useForwardPropsEmits(delegatedProps, emits)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DefineMonthTemplate), null, {
      default: _withCtx(({ date }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatter).custom(_unref(toDate)(date), { month: 'short' })), 1),
            _createVNode(_unref(NativeSelect), {
              class: "text-xs h-8 pr-6 pl-2 text-transparent relative",
              onChange: _cache[0] || (_cache[0] = (e) => {
            placeholder.value = _unref(placeholder).set({
              month: Number((e?.target as any)?.value),
            })
          })
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(createYear)({ dateObj: date }), (month) => {
                  return (_openBlock(), _createBlock(_unref(NativeSelectOption), {
                    key: month.toString(),
                    value: month.month,
                    selected: date.month === month.month
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatter).custom(_unref(toDate)(month), { month: 'short' })), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "selected"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(DefineYearTemplate), null, {
      default: _withCtx(({ date }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatter).custom(_unref(toDate)(date), { year: 'numeric' })), 1),
            _createVNode(_unref(NativeSelect), {
              class: "text-xs h-8 pr-6 pl-2 text-transparent relative",
              onChange: _cache[1] || (_cache[1] = (e) => {
            placeholder.value = _unref(placeholder).set({
              year: Number((e?.target as any)?.value),
            })
          })
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearRange.value, (year) => {
                  return (_openBlock(), _createBlock(_unref(NativeSelectOption), {
                    key: year.toString(),
                    value: year.year,
                    selected: date.year === year.year
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatter).custom(_unref(toDate)(year), { year: 'numeric' })), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "selected"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(CalendarRoot), _mergeProps(_unref(forwarded), {
      placeholder: _unref(placeholder),
      "onUpdate:placeholder": _cache[2] || (_cache[2] = ($event: any) => (_isRef(placeholder) ? (placeholder).value = $event : null)),
      "data-slot": "calendar",
      class: _unref(cn)('p-3', props.class)
    }), {
      default: _withCtx(({ grid, weekDays, date }) => [
        _createVNode(_unref(CalendarHeader), { class: "pt-0" }, {
          default: _withCtx(() => [
            _createElementVNode("nav", _hoisted_7, [
              _createVNode(_unref(CalendarPrevButton), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "calendar-prev-icon")
                ]),
                _: 3
              }),
              _createVNode(_unref(CalendarNextButton), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "calendar-next-icon")
                ]),
                _: 3
              })
            ]),
            _renderSlot(_ctx.$slots, "calendar-heading", {
              date: date,
              month: _unref(ReuseMonthTemplate),
              year: _unref(ReuseYearTemplate)
            }, () => [
              (__props.layout === 'month-and-year')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(ReuseMonthTemplate), { date: date }, null, 8, ["date"]),
                    _createVNode(_unref(ReuseYearTemplate), { date: date }, null, 8, ["date"])
                  ]))
                : (__props.layout === 'month-only')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_unref(ReuseMonthTemplate), { date: date }, null, 8, ["date"]),
                      _createTextVNode(" " + _toDisplayString(_unref(formatter).custom(_unref(toDate)(date), { year: 'numeric' })), 1)
                    ]))
                  : (__props.layout === 'year-only')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_unref(formatter).custom(_unref(toDate)(date), { month: 'short' })) + " ", 1),
                        _createVNode(_unref(ReuseYearTemplate), { date: date }, null, 8, ["date"])
                      ]))
                    : (_openBlock(), _createBlock(_unref(CalendarHeading), { key: 3 }))
            ])
          ]),
          _: 2
        }, 1024),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grid, (month) => {
            return (_openBlock(), _createBlock(_unref(CalendarGrid), {
              key: month.value.toString()
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CalendarGridHead), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CalendarGridRow), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                          return (_openBlock(), _createBlock(_unref(CalendarHeadCell), { key: day }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(day), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(CalendarGridBody), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.rows, (weekDates, index) => {
                      return (_openBlock(), _createBlock(_unref(CalendarGridRow), {
                        key: `weekDate-${index}`,
                        class: "mt-2 w-full"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates, (weekDate) => {
                            return (_openBlock(), _createBlock(_unref(CalendarCell), {
                              key: weekDate.toString(),
                              date: weekDate
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CalendarCellTrigger), {
                                  day: weekDate,
                                  month: month.value
                                }, null, 8, ["day", "month"])
                              ]),
                              _: 2
                            }, 1032, ["date"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 3
    }, 16, ["placeholder", "class"])
  ], 64))
}
}

})